import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { User } from '../../model/user/user.model';
import { AppSettingsService } from '../../services/app/appSettings.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class AuthService {
  private loggedIn = new BehaviorSubject<boolean>(false);

  private currentToken: string;
  private userLogin: string;

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(private http: HttpClient, private SettingsService: AppSettingsService) { }

  login(user: User) {

    if (user.name !== '' && user.password !== '') {
      this.loggedIn.next(true);
    }
  }

  getAuthToken() {
    return localStorage.getItem('userToken');
  }

  logout() {

    localStorage.removeItem('userToken');
    this.loggedIn.next(false);
  }
}
